export const GET_DOCTORS_REQUEST = "GET_DOCTORS_REQUEST"
export const GET_DOCTORS_SUCCESS = "GET_DOCTORS_SUCCESS"
export const GET_DOCTORS_ERROR = "GET_DOCTORS_ERROR"
export const DOCTORS_RESET_STORE = "DOCTORS_RESET_STORE"
export const GET_AVAILABLE_DOCTORS_REQUEST = "GET_AVAILABLE_DOCTORS_REQUEST"
export const GET_AVAILABLE_DOCTORS_SUCCESS = "GET_AVAILABLE_DOCTORS_SUCCESS"
export const GET_AVAILABLE_DOCTORS_ERROR = "GET_AVAILABLE_DOCTORS_ERROR"
export const RESEARCH_DOCTOR_SUCCESS = "RESEARCH_DOCTOR_SUCCESS"
export const RESEARCH_DOCTOR_REQUEST = "RESEARCH_DOCTOR_REQUEST"
